import React from "react";
import { useSelector } from "react-redux";
import EYE_ICON from "../../../../assets/images/EYE_ICON.png";

const TourDocuments = () => {
  const TourDetails = useSelector((state) => state.packageDetail.TourDetails);

  const handleOpenDoc = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="accordion-date-body">
      <ul>
        {TourDetails?.tourDocuments?.map((doc) => (
          <li className="accordion-date">
            <p
              style={{
                display: "inline-block",
                marginRight: "20px",
                fontWeight: 500,
              }}
            >
              {doc?.Title}
            </p>
            <img
              className="eye-loc"
              src={EYE_ICON}
              onClick={() => handleOpenDoc(doc?.Documents)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TourDocuments;
